import classNames from 'classnames';
import { createElement } from 'react';
import { preventJavascriptUrls } from '../../../../../../services/security';
import { withData } from '../../../../../hoc/withData';
import styles from './style.m.less';

const defaultRenderer = d => d.link;

export default function RichLink({ resolve = {}, render, renderPending, renderError, getIcon, isErrorState, data }) {
    const wrapperProps = {
        icon: getIcon(data),
        link: data.link,
    };

    const mainComponent = props => {
        const error = isErrorState ? isErrorState(props) : false;
        const propsWithError = { ...wrapperProps, error };
        return <Wrapper {...propsWithError}>{render(props)}</Wrapper>;
    };

    const body = resolve
        ? withData({
              resolve,
              pendingComponent: () => {
                  const r = renderPending || defaultRenderer;
                  return <Wrapper {...wrapperProps}>{r(data)}</Wrapper>;
              },
              errorComponent: ({ error }) => {
                  const r = renderError || defaultRenderer;
                  const propsWithError = { ...data, error };
                  const wrapperPropsWithError = { ...wrapperProps, error };
                  return <Wrapper {...wrapperPropsWithError}>{r(propsWithError)}</Wrapper>;
              },
          })(mainComponent)
        : mainComponent;

    return createElement(body, data);
}

function Wrapper(props) {
    const { children, error, icon, link } = props;

    const className = classNames(styles.content, {
        [styles.error]: !!error,
    });

    const mainProps = {
        className,
        title: link,
        href: preventJavascriptUrls(link),
        target: '_blank',
    };

    return (
        <a {...mainProps}>
            {icon} {children}
        </a>
    );
}
